<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>{{ id === 'new' ? 'Nuevo' : 'Modificando' }} producto</h3>

          <b-button-group class="mt-1 mb-4">
            <b-button
              @click="typeChanged('online')"
              :pressed="type === 'online'"
              >Online</b-button
            >
            <b-button
              @click="typeChanged('offline')"
              :pressed="type === 'offline'"
              >Offline</b-button
            >
          </b-button-group>

          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <b-form-row>
              <b-form-group
                v-if="type === 'online'"
                id="hidden-product"
                class="col-3"
                label="Ocultar en la web"
                label-for="price"
                description="Si está oculto, significa que no aparecerá en la web, y sólo estará disponible para presupuestar desde el PI. En caso contrario, será visible por los usuarios, que podrán personalizar este producto."
              >
                <b-form-checkbox
                  switch
                  v-model="$v.form.hidden.$model"
                  name="input-hidden"
                  >{{ $v.form.hidden.$model ? 'Sí' : 'No' }}</b-form-checkbox
                >
              </b-form-group>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-reference_' + lang"
                :label="'Nombre (' + languageNames[i] + ')'"
                :label-for="'reference_' + lang"
                class="col-3"
              >
                <b-form-input
                  :id="'reference_' + lang"
                  v-model="$v.form['reference_' + lang].$model"
                  :state="validateStateGlobal('reference_' + lang)"
                  :aria-describedby="'input-reference_' + lang + '- feedback'"
                ></b-form-input>
                <b-form-invalid-feedback
                  :id="'input-reference_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-slug_' + lang"
                :label="'Slug (' + languageNames[i] + ')'"
                :label-for="'slug_' + lang"
                class="col-3"
              >
                <b-form-input
                  :id="'slug_' + lang"
                  v-model="$v.form['slug_' + lang].$model"
                  :state="validateStateGlobal('slug_' + lang)"
                  :aria-describedby="'input-slug_' + lang + '- feedback'"
                ></b-form-input>
                <b-form-invalid-feedback
                  :id="'input-slug_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-description_' + lang"
                :label="'Descripción (' + languageNames[i] + ')'"
                :label-for="'description_' + lang"
                class="col-3"
              >
                <b-form-input
                  :id="'description_' + lang"
                  v-model="$v.form['description_' + lang].$model"
                  :state="validateStateGlobal('description_' + lang)"
                  :aria-describedby="'input-description_' + lang + '- feedback'"
                ></b-form-input>
                <b-form-invalid-feedback
                  :id="'input-description_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <!-- Reference -->
              <!-- <b-form-group
                id="input-reference_es"
                class="col-3"
                label="Nombre"
                label-for="reference_es"
              >
                <b-form-input
                  id="reference_es"
                  :value="$v.form.reference_es.$model"
                  @change="changedName($event)"
                  :state="validateStateGlobal('reference_es')"
                  aria-describedby="input-reference_es-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-reference_es-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group> -->

              <b-form-group id="input-price" class="col-3" label-for="price">
                <b-form-checkbox
                  switch
                  v-model="$v.form.is_price_variable.$model"
                  name="input-is_price_variable"
                  >{{
                    $v.form.is_price_variable.$model
                      ? 'Precio variable'
                      : 'Precio fijo'
                  }}</b-form-checkbox
                >
                <b-input-group class="mt-2" append="€">
                  <b-form-input
                    id="price"
                    :disabled="$v.form.is_price_variable.$model"
                    :state="validateStateGlobal('price')"
                    :value="$v.form.price.$model.replace('.', ',')"
                    @change="setDecimal('price', $event)"
                    aria-describedby="input-price-feedback"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-price-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-input-group>
              </b-form-group>

              <!-- <b-form-group
                v-if="type === 'offline'"
                id="input-description"
                class="col-6"
                label="Descripción"
                label-for="description"
              >
                <b-form-input
                  id="description"
                  v-model="$v.form.description.$model"
                  :state="validateStateGlobal('description')"
                  aria-describedby="input-description-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-description-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group> -->

              <b-form-group
                v-if="type === 'online'"
                id="input-template"
                class="col-3"
                label="Plantilla"
                label-for="template"
              >
                <b-form-select
                  :options="templateOptions"
                  id="template"
                  @change="templateChanged"
                  v-model="$v.form.template.$model"
                  :state="validateStateGlobal('template')"
                  aria-describedby="input-template-feedback"
                ></b-form-select>
                <b-form-invalid-feedback id="input-template-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                v-if="type === 'online'"
                id="input-category"
                class="col-3"
                label="Categoría"
                label-for="category"
              >
                <b-form-select
                  :options="categoryOptions"
                  id="category"
                  v-model="$v.form.category.$model"
                  :state="validateStateGlobal('category')"
                  aria-describedby="input-category-feedback"
                ></b-form-select>
                <b-form-invalid-feedback id="input-category-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-image"
                class="col-3"
                label="Imagen"
                description="Dejar vacío para mantener la imagen actual"
                label-for="image"
              >
                <b-form-file
                  accept="image/*"
                  id="image"
                  v-model="$v.form.image.$model"
                  @input="changedImage"
                  :state="validateStateGlobal('image')"
                  aria-describedby="input-image-feedback"
                  drop-placeholder="Arrastra un archivo aquí..."
                ></b-form-file>
                <b-form-invalid-feedback id="input-image-feedback"
                  >Debes seleccionar una imagen válida (formato PNG o
                  JPEG).</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                label="Vista previa imagen"
                id="input-preview"
                class="col-auto"
              >
                <div>
                  <img style="max-height: 10rem" :src="form.imageURI" />
                </div>
              </b-form-group>

              <b-form-group
                v-if="$v.form.is_price_variable.$model"
                id="input-formula"
                class="col-12"
                label="Fórmula (método antiguo)"
                label-for="formula"
              >
                <b-form-select
                  :options="formulaOptions"
                  id="formula"
                  :disabled="true"
                  @change="priceFormulaChanged"
                  v-model="$v.form.formula.$model"
                  :state="validateStateGlobal('formula')"
                  aria-describedby="input-formula-feedback"
                ></b-form-select>

                <div class="mt-1">{{ currentFormula }}</div>
                <div
                  class="mt-1 text-danger"
                  v-if="currentPriceFormulaUncoveredConstants.length > 0"
                >
                  Las constantes
                  {{ currentPriceFormulaUncoveredConstants.join(', ') }} no
                  están definidas
                </div>

                <div
                  class="mt-1 text-danger"
                  v-if="currentPriceFormulaUncoveredAutoInputs.length > 0"
                >
                  Los inputs autorellenables
                  {{ currentPriceFormulaUncoveredAutoInputs.join(', ') }} no
                  están definidos
                </div>

                <div
                  class="mt-1 text-danger"
                  v-if="currentPriceFormulaUncoveredCuttingSizes.length > 0"
                >
                  Las medidas de corte
                  {{ currentPriceFormulaUncoveredCuttingSizes.join(', ') }} no
                  están definidas
                </div>

                <b-row>
                  <b-col
                    class="mt-3"
                    :cols="12"
                    v-if="form.constants_price.length > 0"
                  >
                    <b-form-row>
                      <b-col
                        :style="
                          i % 2 === 0
                            ? constantBoxStyleLeft
                            : constantBoxStyleRight
                        "
                        :cols="6"
                        v-for="(v, i) in $v.form.constants_price.$each.$iter"
                        :key="i"
                      >
                        <b-form-row>
                          <b-col cols="4">
                            <b-form-group
                              id="input-group-key"
                              label="Constante"
                              label-for="input-key"
                            >
                              <b-input-group prepend="C_">
                                <b-form-input
                                  :disabled="true"
                                  id="key"
                                  v-model="v.key.$model"
                                  @change="changedPriceConstantKey(i)"
                                  :state="validateStatePriceConstant(i, 'key')"
                                  aria-describedby="input-key-feedback"
                                ></b-form-input>
                              </b-input-group> </b-form-group
                          ></b-col>
                          <b-col cols="4">
                            <b-form-group
                              id="input-group-name"
                              label="Nombre"
                              label-for="input-name"
                            >
                              <b-form-input
                                id="name"
                                v-model="v.name.$model"
                                :state="validateStatePriceConstant(i, 'name')"
                                aria-describedby="input-name-feedback"
                              ></b-form-input> </b-form-group
                          ></b-col>
                          <b-col cols="4">
                            <b-form-group
                              id="input-group-value"
                              label="Valor"
                              label-for="input-value"
                            >
                              <b-form-input
                                id="value"
                                :value="v.value.$model.replace('.', ',')"
                                @change="
                                  setDecimalPriceConstant(i, 'value', $event)
                                "
                                :state="validateStatePriceConstant(i, 'value')"
                                aria-describedby="input-value-feedback"
                              ></b-form-input> </b-form-group
                          ></b-col>
                        </b-form-row>
                      </b-col>
                    </b-form-row>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <b-form-group
                id="input-is_discontinued"
                class="col-3"
                label="Descatalogado"
                description="No aparecerá a la hora de elaborar presupuestos"
                label-for="is_discontinued"
              >
                <b-form-checkbox
                  switch
                  v-model="$v.form.is_discontinued.$model"
                  name="input-is_discontinued"
                  >{{
                    $v.form.is_discontinued.$model ? 'Sí' : 'No'
                  }}</b-form-checkbox
                >

                <b-form-invalid-feedback id="input-is_discontinued-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
              <!-- <b-form-group
                id="input-partially_available_stock_can_be_reused"
                class="col-4"
                label="Stock parcial aprovechable"
                description="Dejarlo desactivado significa que, aunque haya stock parcialmente de este producto, siempre se enviarán a fabricar al taller todas las unidades solicitadas (ej. para indicar productos con barcadas, hasta que no tengamos control sobre metros restantes de una barcada (tela) determinada"
                label-for="partially_available_stock_can_be_reused"
              >
                <b-form-checkbox
                  switch
                  v-model="
                    $v.form.partially_available_stock_can_be_reused.$model
                  "
                  name="input-partially_available_stock_can_be_reused"
                  >{{
                    $v.form.partially_available_stock_can_be_reused.$model
                      ? 'Sí'
                      : 'No'
                  }}</b-form-checkbox
                >

                <b-form-invalid-feedback
                  id="input-partially_available_stock_can_be_reused-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group> -->
            </b-form-row>

            <b-row>
              <b-col class="mt-5" :cols="12">
                <h4>
                  Atributos genéricos
                  <b-button
                    variant="outline-primary"
                    size="sm"
                    @click="reAssignProductAttr = true"
                    >Redefinir</b-button
                  >
                </h4>
              </b-col>

              <b-col
                :cols="12"
                v-if="
                  reAssignProductAttr &&
                  genericProductAttributesOptions[0].options.length == 0
                "
                class="text-danger mb-2"
                >Parece que no hay atributos genéricos definidos. Por favor,
                sube antes los atributos genéricos y su jerarquía en la página
                <b-link
                  variant="outline-secondary"
                  :to="{ name: 'AdminGenericProductAttributesScreen' }"
                  >Atributos genéricos</b-link
                >.<br
              /></b-col>
              <b-col :cols="12">
                <b-form-row>
                  <b-col
                    v-for="(v, i) in genericProductAttributesOptions"
                    :key="i"
                    :cols="3"
                  >
                    <b-form-group
                      id="input-template"
                      :label="v.reference"
                      :label-for="v.reference"
                    >
                      <b-form-select
                        v-if="reAssignProductAttr"
                        :options="v.options"
                        :id="v.reference"
                        @change="
                          setGenericProductAttribute(v.reference, $event)
                        "
                        :value="genericProductAttributeValue(v.reference)"
                        aria-describedby="input-template-feedback"
                      ></b-form-select>
                      <b-form-input
                        :disabled="true"
                        v-else
                        :id="v.reference"
                        :value="genericProductAttributeValue(v.reference)"
                        aria-describedby="input-template-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-template-feedback"
                        >Este campo es obligatorio.</b-form-invalid-feedback
                      >
                    </b-form-group>
                  </b-col>
                </b-form-row>
              </b-col>
            </b-row>

            <b-row>
              <b-col class="mt-5" :cols="12">
                <h4>Tareas de taller</h4>
              </b-col>
              <b-col :cols="12">
                <p v-if="!form.product_tasks.length">
                  Esta ficha no tiene tareas de taller vinculadas. Puedes
                  vincularlas desde aquí o mediante la subida vía excel desde el
                  apartado
                  <b-link
                    :to="{
                      name: 'AdminWorkshopTasksScreen',
                      params: {},
                    }"
                    >Tareas de taller</b-link
                  >.
                </p>
                <b-form-row>
                  <b-col cols="12">
                    <b-form-group>
                      <multiselect
                        ref="multiselect"
                        @input="workshopTaskClicked"
                        :options="workshopTasksOptions"
                        :custom-label="workshopTaskNameFmt"
                        placeholder="Selecciona para añadir"
                        label="code"
                        track-by="code"
                      ></multiselect>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <p v-if="form.product_tasks.length">
                      Recuerda que para gestionar las tareas de taller
                      vinculadas a múltiples fichas puedes utilizar la subida
                      vía excel, desde el apartado
                      <b-link
                        :to="{
                          name: 'AdminWorkshopTasksScreen',
                          params: {},
                        }"
                        >Tareas de taller</b-link
                      >.
                    </p>
                    <b-list-group>
                      <b-list-group-item
                        v-for="(productTask, index) in form.product_tasks"
                        :key="productTask.code"
                      >
                        <b-row class="justify-content-between">
                          <b-col cols="auto" class="align-content-center"
                            >{{ productTask.code }} -
                            {{ productTask.description }}</b-col
                          >
                          <b-col cols="auto">
                            <b-button-group>
                              <!-- <b-button
                                v-if="index > 0"
                                variant="outline-primary"
                                size="sm"
                                @click="moveProductTaskUp(index)"
                              >
                                <b-icon icon="arrow-up"></b-icon>
                              </b-button>

                              <b-button
                                v-if="index < form.product_tasks.length - 1"
                                variant="outline-primary"
                                size="sm"
                                @click="moveProductTaskDown(index)"
                              >
                                <b-icon icon="arrow-down"></b-icon>
                              </b-button> -->

                              <b-button
                                size="sm"
                                variant="danger"
                                @click="deleteTask(productTask.code, index)"
                                >Eliminar</b-button
                              >
                            </b-button-group>
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                    </b-list-group>
                  </b-col>
                </b-form-row>
              </b-col>
            </b-row>

            <b-row class="mt-5" v-if="enableTextileComponentsSection">
              <b-col :cols="12">
                <h4>
                  {{
                    type === 'online' ? 'Selectores' : 'Componentes textiles'
                  }}
                </h4>
                <b-button
                  variant="outline-primary"
                  v-if="type === 'offline'"
                  @click="addTextileComponent"
                  >Nuevo componente</b-button
                >
              </b-col>
              <b-col :cols="12">
                <b-form-row
                  class="mt-2"
                  v-for="(v, i) in $v.form.textile_components.$each.$iter"
                  :key="i"
                >
                  <b-col :cols="2">
                    <b-form-group label="Nombre">
                      <b-input-group>
                        <b-form-input
                          id="name"
                          :disabled="type === 'online'"
                          :value="v.name.$model.replace('.', ',')"
                          @change="
                            setDecimalTextileComponent(i, 'name', $event);
                            textileComponentTypeChanged();
                          "
                          :state="validateStateTextileComponent(i, 'name')"
                          aria-describedby="input-name-feedback"
                        ></b-form-input>
                        <template #append>
                          <b-button
                            @click="removeTextileComponent(i)"
                            :disabled="type === 'online'"
                            variant="outline-danger"
                            ><b-icon icon="trash"></b-icon
                          ></b-button>
                        </template>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="10">
                    <b-form-row>
                      <b-col :cols="2">
                        <b-form-group
                          id="form-group-selector_type"
                          label-for="selector_type"
                          label="Tipo"
                        >
                          <b-form-select
                            :disabled="type === 'online'"
                            :state="
                              validateStateTextileComponent(i, 'selector_type')
                            "
                            @change="textileComponentTypeChanged"
                            :options="
                              type === 'offline'
                                ? textileComponentsSelectableAttributeTypes.filter(
                                    (x) => x != 'TAMANO'
                                  )
                                : textileComponentsSelectableAttributeTypes
                            "
                            id="selector_type"
                            v-model="v.selector_type.$model"
                          ></b-form-select>
                        </b-form-group>
                      </b-col>
                      <b-col
                        :cols="3"
                        v-if="
                          ![
                            'BORDADO',
                            'INICIALES',
                            'TAMANO_LIBRE',
                            'TAMANO_LIBRE_CAMA',
                          ].includes(v.selector_type.$model)
                        "
                      >
                        <b-form-group
                          id="form-group-selector_id"
                          label-for="selector_id"
                          label="Selector"
                        >
                          <b-form-select
                            :state="
                              validateStateTextileComponent(i, 'selector_id')
                            "
                            :options="
                              attributeSelectorOptions[v.selector_type.$model]
                            "
                            id="selector_id"
                            v-model="v.selector_id.$model"
                          ></b-form-select>
                        </b-form-group>
                      </b-col>
                      <b-col
                        :cols="3"
                        v-if="
                          ['TAMANO', 'TELA', 'PUNTADA', 'HILO'].includes(
                            v.selector_type.$model
                          )
                        "
                      >
                        <b-form-group
                          id="form-group-selector_default_value"
                          label-for="selector_default_value"
                          label="Valor por defecto"
                        >
                          <b-form-select
                            :state="
                              validateStateTextileComponent(
                                i,
                                'selector_default_value'
                              )
                            "
                            :options="
                              attributeSelectorDefaultOptions[
                                v.selector_id.$model
                              ]
                            "
                            v-model="v.selector_default_value.$model"
                            id="selector_default_value"
                          ></b-form-select>
                        </b-form-group>
                      </b-col>
                      <!-- Iniciales special selector -->
                      <b-col
                        :cols="3"
                        v-if="['INICIALES'].includes(v.selector_type.$model)"
                      >
                        <b-form-group
                          id="form-group-selector_default_value"
                          label-for="selector_default_value"
                          label="Valor por defecto"
                          description="Ejemplo: FB,XS,Praga,Black"
                        >
                          <b-form-input
                            :state="
                              validateStateTextileComponent(
                                i,
                                'selector_default_value'
                              )
                            "
                            v-model="v.selector_default_value.$model"
                            id="selector_default_value"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                  </b-col>
                </b-form-row>
              </b-col>
            </b-row>

            <b-row class="mt-5">
              <b-col :cols="12">
                <h4>Entretelas</h4>
                <b-button variant="outline-primary" @click="addInterlining"
                  >Nueva entretela</b-button
                >
              </b-col>
              <b-col
                class="mt-3"
                :cols="12"
                v-if="form.interlinings.length > 0"
              >
                <b-form-row>
                  <b-col :cols="2"><label>Entretela</label></b-col>

                  <b-col :cols="2"><label></label></b-col>
                </b-form-row>
                <b-form-row
                  v-for="(v, i) in $v.form.interlinings.$each.$iter"
                  :key="i"
                >
                  <b-col :cols="2">
                    <b-form-group
                      id="input-group-interlining_id"
                      label-for="input-interlining_id"
                    >
                      <b-form-select
                        id="interlining_id"
                        v-model="v.interlining_id.$model"
                        :options="interliningOptions"
                        @change="populateCuttingSizes()"
                        :state="validateStateInterlining(i, 'interlining_id')"
                        aria-describedby="input-interlining_id-feedback"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>

                  <b-col :cols="2">
                    <b-button
                      @click="removeInterlining(i)"
                      variant="outline-danger"
                      ><b-icon icon="trash"></b-icon
                    ></b-button>
                  </b-col>
                </b-form-row>
              </b-col>
            </b-row>

            <b-row class="mt-5" v-if="form.cutting_sizes.length > 0">
              <b-col :cols="12">
                <h4>Medidas de corte</h4>
              </b-col>
              <b-col class="mt-3" :cols="12">
                <b-form-row
                  v-for="(v, i) in $v.form.cutting_sizes.$each.$iter"
                  :key="i"
                >
                  <b-col :cols="2">
                    <b-form-group
                      id="input-group-name"
                      label="Elemento"
                      label-for="input-name"
                    >
                      <b-form-input
                        id="name"
                        :disabled="true"
                        :value="v.name.$model"
                        :state="validateStateCuttingSize(i, 'name')"
                        aria-describedby="input-name-feedback"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col :cols="10">
                    <b-form-row>
                      <b-col :cols="6">
                        <b-form-group
                          id="input-group-formula_width"
                          label-for="input-formula_width"
                        >
                          <div slot="label">
                            <span>
                              {{
                                v.type_dimension.$model === 'rectangle'
                                  ? 'Fórmulas (Ancho y Largo)'
                                  : 'Fórmula (Diámetro)'
                              }}</span
                            >
                            <span style="float: right">
                              <b-form-checkbox
                                inline
                                value="rectangle"
                                unchecked-value="circle"
                                switch
                                v-model="v.type_dimension.$model"
                                name="input-quote_discounts_over_tax"
                                >{{
                                  v.type_dimension.$model === 'rectangle'
                                    ? 'Ancho x Largo'
                                    : 'Diámetro'
                                }}</b-form-checkbox
                              ></span
                            >
                          </div>
                          <b-form-row
                            v-if="v.type_dimension.$model === 'rectangle'"
                          >
                            <b-col cols="6">
                              <b-form-input
                                id="formula_width"
                                :disabled="
                                  [
                                    'embroidered_strip',
                                    'embroidered_strip_plane',
                                  ].includes(v.type.$model)
                                "
                                @change="
                                  setDecimalCuttingSize(
                                    i,
                                    'formula_width',
                                    $event
                                  );
                                  cuttingSizeFormulaChanged(i);
                                "
                                :value="
                                  v.formula_width.$model.replace('.', ',')
                                "
                                :state="
                                  validateStateCuttingSize(i, 'formula_width')
                                "
                                aria-describedby="input-formula_width-help input-formula_width-feedback"
                              ></b-form-input>
                              <b-form-text id="input-formula_width-help"
                                >Ancho</b-form-text
                              >
                            </b-col>
                            <b-col cols="6">
                              <b-form-input
                                id="formula_length"
                                @change="
                                  setDecimalCuttingSize(
                                    i,
                                    'formula_length',
                                    $event
                                  );
                                  cuttingSizeFormulaChanged(i);
                                "
                                :value="
                                  v.formula_length.$model.replace('.', ',')
                                "
                                :state="
                                  validateStateCuttingSize(i, 'formula_length')
                                "
                                aria-describedby="input-formula_length-help input-formula_length-feedback"
                              ></b-form-input>
                              <b-form-text id="input-formula_length-help"
                                >Largo</b-form-text
                              >
                            </b-col>
                          </b-form-row>

                          <b-form-row
                            v-if="v.type_dimension.$model === 'circle'"
                          >
                            <b-col cols="12">
                              <b-form-input
                                id="formula_diameter"
                                @change="
                                  setDecimalCuttingSize(
                                    i,
                                    'formula_diameter',
                                    $event
                                  );
                                  cuttingSizeFormulaChanged(i);
                                "
                                :value="
                                  v.formula_diameter.$model.replace('.', ',')
                                "
                                :state="
                                  validateStateCuttingSize(
                                    i,
                                    'formula_diameter'
                                  )
                                "
                                aria-describedby="input-formula_diameter-help input-formula_diameter-feedback"
                              ></b-form-input>
                              <b-form-text id="input-formula_diameter-help"
                                >Diámetro</b-form-text
                              >
                            </b-col>
                          </b-form-row>

                          <b-col cols="12">
                            <div
                              class="mt-1 text-danger"
                              v-if="
                                cuttingSizesFormulaUncoveredConstants.length >
                                  i &&
                                cuttingSizesFormulaUncoveredConstants[i]
                                  .length > 0
                              "
                            >
                              Las constantes
                              {{
                                cuttingSizesFormulaUncoveredConstants[i].join(
                                  ', '
                                )
                              }}
                              no están definidas
                            </div>
                          </b-col>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                  </b-col>
                </b-form-row>
              </b-col>
              <b-col cols="12">
                <b-row>
                  <b-col
                    class="mt-3"
                    :cols="12"
                    v-if="form.constants_cutting_sizes.length > 0"
                  >
                    <b-form-row>
                      <b-col
                        :style="
                          i % 2 === 0
                            ? constantBoxStyleLeft
                            : constantBoxStyleRight
                        "
                        :cols="6"
                        v-for="(v, i) in $v.form.constants_cutting_sizes.$each
                          .$iter"
                        :key="i"
                      >
                        <b-form-row>
                          <b-col cols="4">
                            <b-form-group
                              id="input-group-key"
                              label="Constante"
                              label-for="input-key"
                            >
                              <b-input-group prepend="C_">
                                <b-form-input
                                  :disabled="true"
                                  id="key"
                                  v-model="v.key.$model"
                                  @change="changedCuttingSizeConstantKey(i)"
                                  :state="
                                    validateStateCuttingSizeConstant(i, 'key')
                                  "
                                  aria-describedby="input-key-feedback"
                                ></b-form-input>
                              </b-input-group> </b-form-group
                          ></b-col>
                          <b-col cols="4">
                            <b-form-group
                              id="input-group-name"
                              label="Nombre"
                              label-for="input-name"
                            >
                              <b-form-input
                                id="name"
                                v-model="v.name.$model"
                                :state="
                                  validateStateCuttingSizeConstant(i, 'name')
                                "
                                aria-describedby="input-name-feedback"
                              ></b-form-input> </b-form-group
                          ></b-col>
                          <b-col cols="4">
                            <b-form-group
                              id="input-group-value"
                              label="Valor"
                              label-for="input-value"
                            >
                              <b-form-input
                                id="value"
                                :value="v.value.$model.replace('.', ',')"
                                @change="
                                  setDecimalCuttingSizeConstant(
                                    i,
                                    'value',
                                    $event
                                  )
                                "
                                :state="
                                  validateStateCuttingSizeConstant(i, 'value')
                                "
                                aria-describedby="input-value-feedback"
                              ></b-form-input> </b-form-group
                          ></b-col>
                        </b-form-row>
                      </b-col>
                    </b-form-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="mt-5" v-if="form.is_price_variable">
              <b-col :cols="12">
                <h4>Costes</h4>
                <b-button variant="outline-primary" @click="addCost"
                  >Nuevo coste</b-button
                >
              </b-col>
              <b-col class="mt-3" :cols="12">
                <b-form-row
                  v-for="(v, i) in $v.form.costs.$each.$iter"
                  :key="i"
                >
                  <b-col :cols="2">
                    <b-form-group label="Nombre">
                      <b-input-group>
                        <b-form-input
                          id="name"
                          v-model="v.name.$model"
                          :state="validateStateCost(i, 'name')"
                          aria-describedby="input-name-feedback"
                        ></b-form-input>
                        <template #append>
                          <b-button
                            @click="removeCost(i)"
                            variant="outline-danger"
                            ><b-icon icon="trash"></b-icon
                          ></b-button>
                        </template>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col :cols="10">
                    <b-form-row>
                      <b-col :cols="12">
                        <b-form-group
                          label="Fórmula"
                          id="input-group-formula"
                          label-for="input-formula"
                        >
                          <b-form-row>
                            <b-col cols="12">
                              <b-form-input
                                id="formula"
                                @change="
                                  setDecimalCost(i, 'formula', $event);
                                  costFormulaChanged(i);
                                "
                                :value="v.formula.$model.replace('.', ',')"
                                :state="validateStateCost(i, 'formula')"
                                aria-describedby="input-formula-feedback"
                              ></b-form-input>
                            </b-col>
                          </b-form-row>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                  </b-col>
                </b-form-row>
              </b-col>
              <b-col cols="12">
                <b-row>
                  <b-col
                    class="mt-3"
                    :cols="12"
                    v-if="form.constants_costs.length > 0"
                  >
                    <b-form-row>
                      <b-col
                        :style="
                          i % 2 === 0
                            ? constantBoxStyleLeft
                            : constantBoxStyleRight
                        "
                        :cols="6"
                        v-for="(v, i) in $v.form.constants_costs.$each.$iter"
                        :key="i"
                      >
                        <b-form-row>
                          <b-col cols="4">
                            <b-form-group
                              id="input-group-key"
                              label="Constante"
                              label-for="input-key"
                            >
                              <b-input-group prepend="C_">
                                <b-form-input
                                  :disabled="true"
                                  id="key"
                                  v-model="v.key.$model"
                                  @change="changedCostConstantKey(i)"
                                  :state="validateStateCostConstant(i, 'key')"
                                  aria-describedby="input-key-feedback"
                                ></b-form-input>
                              </b-input-group> </b-form-group
                          ></b-col>
                          <b-col cols="4">
                            <b-form-group
                              id="input-group-name"
                              label="Nombre"
                              label-for="input-name"
                            >
                              <b-form-input
                                id="name"
                                v-model="v.name.$model"
                                :state="validateStateCostConstant(i, 'name')"
                                aria-describedby="input-name-feedback"
                              ></b-form-input> </b-form-group
                          ></b-col>
                          <b-col cols="4">
                            <b-form-group
                              id="input-group-value"
                              label="Valor"
                              label-for="input-value"
                            >
                              <b-form-input
                                id="value"
                                :value="v.value.$model.replace('.', ',')"
                                @change="
                                  setDecimalCostConstant(i, 'value', $event)
                                "
                                :state="validateStateCostConstant(i, 'value')"
                                aria-describedby="input-value-feedback"
                              ></b-form-input> </b-form-group
                          ></b-col>
                        </b-form-row>
                      </b-col>
                    </b-form-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="mt-5" v-if="form.is_price_variable">
              <b-col :cols="12">
                <h4>Precio</h4>
              </b-col>
              <b-col class="mt-3" :cols="12">
                <b-form-row>
                  <b-col :cols="2">
                    <b-form-group
                      id="input-group-profit_margin"
                      label="Margen de beneficio"
                      description="A aplicar sobre la suma de costes del producto"
                      label-for="input-profit_margin"
                    >
                      <b-input-group>
                        <b-form-input
                          id="profit_margin"
                          v-model="$v.form.profit_margin.$model"
                          :state="validateStateGlobal('profit_margin')"
                          aria-describedby="input-profit_margin-feedback"
                        ></b-form-input>
                        <template #append>
                          <b-input-group-text>%</b-input-group-text>
                        </template>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-form-row>
              </b-col>
            </b-row>

            <b-row class="mt-5" v-if="type === 'offline'">
              <b-col :cols="12">
                <h4>Campos dinámicos</h4>
                <p>
                  Define aquí los campos que podrás rellenar al incluir este
                  producto en un presupuesto.
                </p>
              </b-col>

              <b-col :cols="12">
                <b-form-row
                  class="my-2"
                  v-for="(v, index) in $v.form.attributes.$each.$iter"
                  :key="index"
                >
                  <b-col sm="3" class="vertical-align">
                    <span v-if="!v.is_input.$model" :for="`option-${index}`"
                      >Campo #{{ index }}</span
                    >
                    <span v-else :for="`option-${index}`">{{
                      v.input.$model
                    }}</span>
                  </b-col>
                  <b-col sm="9">
                    <b-form-group
                      class="m-0"
                      :id="`input-group-option-${index}`"
                      :label-for="`option-${index}`"
                    >
                      <b-input-group>
                        <b-form-input
                          :id="`option-${index}`"
                          v-model="v.name.$model"
                          :state="validateStateAttributes(index, 'name')"
                          :aria-describedby="`input-name-option-${index}`"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            v-if="index > 0"
                            variant="outline-primary"
                            size="sm"
                            @click="moveUp(index)"
                          >
                            <b-icon icon="arrow-up"></b-icon>
                          </b-button>
                          <b-button
                            v-if="index < form.attributes.length - 1"
                            variant="outline-primary"
                            size="sm"
                            @click="moveDown(index)"
                          >
                            <b-icon icon="arrow-down"></b-icon>
                          </b-button>
                          <b-button
                            size="sm"
                            :disabled="v.is_input.$model === true"
                            @click="removeAttribute(index)"
                            >Eliminar</b-button
                          >
                        </b-input-group-append>
                      </b-input-group>
                      <b-form-invalid-feedback
                        :state="validateStateAttributes(index, 'name')"
                        :id="`input-name-option-${index}`"
                        >Este campo es obligatorio.</b-form-invalid-feedback
                      >
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-row class="mb-2">
                  <b-col sm="3" class="vertical-align">
                    <span
                      ><b-button type="button" size="sm" @click="addAttribute"
                        >Añadir
                        {{ form.attributes.length > 0 ? 'nuevo' : '' }}
                        campo</b-button
                      ></span
                    >
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="mt-5" v-if="enableInitialsSection">
              <b-col :cols="12">
                <h4>Iniciales</h4>
                <b-button variant="outline-primary" @click="addInitialSize"
                  >Añadir tamaño</b-button
                >
              </b-col>
              <b-col
                class="mt-3"
                :cols="12"
                v-if="form.initials_sizes.length > 0"
              >
                <b-form-row>
                  <b-col :cols="2"><label>Tamaño</label></b-col>
                  <b-col :cols="2"><label>Precio</label></b-col>
                  <b-col :cols="2"><label></label></b-col>
                </b-form-row>
                <b-form-row
                  v-for="(v, i) in $v.form.initials_sizes.$each.$iter"
                  :key="i"
                >
                  <b-col :cols="2">
                    <b-form-group id="input-group-size" label-for="input-size">
                      <b-form-select
                        id="size"
                        @change="InitialSizeChanged(i)"
                        v-model="v.size.$model"
                        :options="initialsSizesOptions"
                        :state="validateStateInitialsSizes(i, 'size')"
                        aria-describedby="input-size-feedback"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>

                  <b-col :cols="2">
                    <b-form-group
                      id="input-group-price"
                      label-for="input-price"
                    >
                      <b-input-group append="€">
                        <b-form-input
                          id="price"
                          :value="v.price.$model.replace('.', ',')"
                          @change="setDecimalInitialsSizes(i, 'price', $event)"
                          :state="validateStateInitialsSizes(i, 'price')"
                          aria-describedby="input-price-feedback"
                        ></b-form-input>
                      </b-input-group> </b-form-group
                  ></b-col>

                  <b-col :cols="2">
                    <b-button
                      @click="removeInitialSize(i)"
                      variant="outline-danger"
                      ><b-icon icon="trash"></b-icon
                    ></b-button>
                  </b-col>
                </b-form-row>
              </b-col>
            </b-row>

            <b-row class="mt-5" v-if="enableEmbroideriesSection">
              <b-col :cols="12">
                <h4>Bordados</h4>
                <b-button @click="addEmbroiderySize" variant="outline-primary"
                  >Añadir tamaño</b-button
                >
              </b-col>
              <b-col
                class="mt-3"
                :cols="12"
                v-if="form.embroideries_sizes.length > 0"
              >
                <b-form-row>
                  <b-col :cols="12">
                    <b-form-row>
                      <b-col cols="2">Tamaño</b-col>
                      <b-col cols="2">Altura</b-col>
                      <b-col cols="2">Precio monocolor</b-col>
                      <b-col cols="2">Precio multicolor</b-col>
                    </b-form-row>
                  </b-col>
                </b-form-row>

                <b-form-row
                  v-for="(v, i) in $v.form.embroideries_sizes.$each.$iter"
                  :key="i"
                >
                  <b-col cols="2">
                    <b-form-group
                      id="input-group-turnover"
                      label-for="input-turnover"
                    >
                      <b-form-select
                        id="size"
                        v-model="v.size.$model"
                        :options="embroideriesSizesOptions"
                        @change="EmbroiderySizeChanged(i)"
                        :state="validateStateEmbroiderySize(i, 'size')"
                        aria-describedby="input-size-feedback"
                      ></b-form-select> </b-form-group
                  ></b-col>
                  <b-col cols="2">
                    <b-form-group
                      id="input-group-height"
                      label-for="input-height"
                    >
                      <b-input-group append="cm">
                        <b-form-input
                          id="height"
                          :value="v.height.$model.replace('.', ',')"
                          @change="
                            setDecimalEmbroiderySize(i, 'height', $event)
                          "
                          :state="validateStateEmbroiderySize(i, 'height')"
                          aria-describedby="input-height-feedback"
                        ></b-form-input>
                      </b-input-group> </b-form-group
                  ></b-col>
                  <b-col cols="2">
                    <b-form-group
                      id="input-group-price_unicolor"
                      label-for="input-price_unicolor"
                    >
                      <b-input-group append="€">
                        <b-form-input
                          id="price_unicolor"
                          :value="v.price_unicolor.$model.replace('.', ',')"
                          @change="
                            setDecimalEmbroiderySize(
                              i,
                              'price_unicolor',
                              $event
                            )
                          "
                          :state="
                            validateStateEmbroiderySize(i, 'price_unicolor')
                          "
                          aria-describedby="input-price_unicolor-feedback"
                        ></b-form-input>
                      </b-input-group> </b-form-group
                  ></b-col>

                  <b-col cols="2">
                    <b-form-group
                      id="input-group-price_multicolor"
                      label-for="input-price_multicolor"
                    >
                      <b-input-group append="€">
                        <b-form-input
                          id="price_multicolor"
                          :value="v.price_multicolor.$model.replace('.', ',')"
                          @change="
                            setDecimalEmbroiderySize(
                              i,
                              'price_multicolor',
                              $event
                            )
                          "
                          :state="
                            validateStateEmbroiderySize(i, 'price_multicolor')
                          "
                          aria-describedby="input-price_multicolor-feedback"
                        ></b-form-input>
                      </b-input-group> </b-form-group
                  ></b-col>

                  <b-col :cols="2">
                    <b-button
                      @click="removeEmbroiderySize(i)"
                      variant="outline-danger"
                      ><b-icon icon="trash"></b-icon
                    ></b-button>
                  </b-col>
                </b-form-row>
              </b-col>
            </b-row>

            <b-row class="mt-5">
              <b-col cols="12">
                <b-button type="submit" variant="primary">
                  {{
                    id === 'new' ? 'Guardar nuevo producto' : 'Guardar producto'
                  }}</b-button
                >
              </b-col>
            </b-row>
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  required,
  minLength,
  decimal,
  numeric,
  requiredIf,
  minValue,
} from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import { helpers } from 'vuelidate/lib/validators';
import Multiselect from 'vue-multiselect';
const isValidImage = (image) =>
  !helpers.req(image) || ['image/jpeg', 'image/png'].includes(image['type']);

export default {
  name: 'AdminProductsEditScreen',
  props: ['id'],
  components: { Multiselect },
  mixins: [validationMixin],
  validations() {
    let rules_online = {
      reference: {},
      slug: {},
      profit_margin: {},
      price: {
        required,
        decimal,
        minValue: minValue(0.0),
      },
      is_price_variable: {
        required,
      },
      hidden: {
        required,
      },
      formula: {
        // required: requiredIf(function (form) {
        //   return form.is_price_variable;
        // }),
      },
      // selector_size: {
      //   required: requiredIf(function (form) {
      //     return this.enableSizeSelectorInput;
      //   }),
      // },
      generic_product_attributes: {},
      template: {
        required,
      },
      category: {
        required,
      },
      image: {
        isValidImage,
      },
      is_discontinued: { required },
      partially_available_stock_can_be_reused: { required },
      textile_components: {
        $each: {
          name: {},
          selector_id: {
            required: requiredIf(function (nestedTC) {
              return ![
                'BORDADO',
                'INICIALES',
                'TAMANO_LIBRE',
                'TAMANO_LIBRE_CAMA',
              ].includes(nestedTC.selector_type);
            }),
          },
          selector_type: { required },
          selector_default_value: {
            required: requiredIf(function (nestedTC) {
              return [
                'TAMANO',
                'TELA',
                'PUNTADA',
                'HILO',
                'INICIALES',
              ].includes(nestedTC.selector_type);
            }),
          },
        },
      },
      interlinings: {
        $each: {
          interlining_id: { required, decimal, minValue: minValue(0.0) },
        },
      },
      cutting_sizes: {
        $each: {
          type: { required }, // textile or interlining
          index: { required, numeric },
          name: { required },
          formula_width: {
            required: requiredIf(function (nestedTC) {
              return (
                'rectangle' === nestedTC.type_dimension &&
                !['embroidered_strip', 'embroidered_strip_plane'].includes(
                  nestedTC.type
                )
              );
            }),
          },
          formula_length: {
            required: requiredIf(function (nestedTC) {
              return 'rectangle' === nestedTC.type_dimension;
            }),
          },
          formula_diameter: {
            required: requiredIf(function (nestedTC) {
              return 'circle' === nestedTC.type_dimension;
            }),
          },
          type_dimension: { required },
        },
      },
      costs: {
        $each: {
          type: { required }, // textile or interlining
          index: { required, numeric },
          name: { required },
          formula: {
            required,
          },
        },
      },
      constants_price: {
        $each: {
          key: { required }, // textile or interlining
          name: { required },
          value: { decimal, required },
        },
      },
      constants_cutting_sizes: {
        $each: {
          key: { required }, // textile or interlining
          name: { required },
          value: { required },
        },
      },
      constants_costs: {
        $each: {
          key: { required }, // textile or interlining
          name: { required },
          value: { required },
        },
      },
      initials_sizes: {
        $each: {
          size: { required },
          price: { required, decimal, minValue: minValue(0.0) },
        },
      },
      embroideries_sizes: {
        $each: {
          size: { required },
          height: { required },
          price_unicolor: { required, decimal, minValue: minValue(0.0) },
          price_multicolor: { required, decimal, minValue: minValue(0.0) },
        },
      },
    };

    this.languageCodes.map((x) => {
      // Only 'es' lang required
      rules_online['reference_' + x] = { required };
      rules_online['slug_' + x] = { required };
      rules_online['description_' + x] = x === 'es' ? {} : {};
    });

    let rules_offline = {
      reference: {},
      slug: {},
      description: {},
      is_price_variable: {
        required,
      },
      hidden: {
        required,
      },
      formula: {
        // required: requiredIf(function (form) {
        //   return form.is_price_variable;
        // }),
      },
      // selector_size: {},
      generic_product_attributes: {},

      profit_margin: {},
      price: {
        required,
        decimal,
        minValue: minValue(0.0),
      },
      image: {
        isValidImage,
      },

      is_discontinued: { required },
      partially_available_stock_can_be_reused: { required },

      textile_components: {
        $each: {
          name: { required },
          selector_id: {
            required: requiredIf(function (nestedTC) {
              return ![
                'BORDADO',
                'INICIALES',
                'TAMANO_LIBRE',
                'TAMANO_LIBRE_CAMA',
              ].includes(nestedTC.selector_type);
            }),
          },
          selector_default_value: {},
          selector_type: { required },
        },
      },
      interlinings: {
        $each: {
          interlining_id: { required, decimal, minValue: minValue(0.0) },
        },
      },
      cutting_sizes: {
        $each: {
          type: { required }, // textile or interlining
          index: { required, numeric },
          name: { required },
          formula_width: {
            required: requiredIf(function (nestedTC) {
              return (
                'rectangle' === nestedTC.type_dimension &&
                !['embroidered_strip', 'embroidered_strip_plane'].includes(
                  nestedTC.type
                )
              );
            }),
          },
          formula_length: {
            required: requiredIf(function (nestedTC) {
              return 'rectangle' === nestedTC.type_dimension;
            }),
          },
          formula_diameter: {
            required: requiredIf(function (nestedTC) {
              return 'circle' === nestedTC.type_dimension;
            }),
          },
          type_dimension: { required },
        },
      },
      costs: {
        $each: {
          type: { required }, // textile or interlining
          index: { required, numeric },
          name: { required },
          formula: {
            required,
          },
        },
      },
      constants_price: {
        $each: {
          key: { required }, // textile or interlining
          name: { required },
          value: { decimal, required },
        },
      },
      constants_cutting_sizes: {
        $each: {
          key: { required }, // textile or interlining
          name: { required },
          value: { required },
        },
      },
      constants_costs: {
        $each: {
          key: { required }, // textile or interlining
          name: { required },
          value: { required },
        },
      },
      initials_sizes: {
        $each: {
          size: { required },
          price: { required, decimal, minValue: minValue(0.0) },
        },
      },
      embroideries_sizes: {
        $each: {
          size: { required },
          height: { required },
          price_unicolor: { required, decimal, minValue: minValue(0.0) },
          price_multicolor: { required, decimal, minValue: minValue(0.0) },
        },
      },
      attributes: {
        $each: {
          is_input: { required }, //
          name: { required },
          input: {},
        },
      },
    };

    this.languageCodes.map((x) => {
      // Only 'es' lang required
      rules_offline['reference_' + x] = { required };
      rules_offline['slug_' + x] = { required };
      rules_offline['description_' + x] = x === 'es' ? {} : {};

      // rules['description_' + x] = x === 'es' ? { required } : {};
    });

    return {
      form: this.type === 'online' ? rules_online : rules_offline,
    };
  },
  data() {
    let form = {
      reference: '',
      slug: '',
      price: '0.0',
      template: null,
      category: null,
      is_discontinued: false,
      partially_available_stock_can_be_reused: true,
      image: null,
      imageURI: null,
      formula: null,
      // selector_size: null,
      textile_components: [],
      interlinings: [],
      generic_product_attributes: {},
      cutting_sizes: [],
      costs: [],
      constants_price: [],
      constants_cutting_sizes: [],
      constants_costs: [],
      attributes: [], // offline
      initials_sizes: [],
      embroideries_sizes: [],
      description: '', // offline
      is_price_variable: false,
      product_tasks: [],
      hidden: false,
      profit_margin: '',
      error: {
        show: false,
        text: '',
      },
    };

    store.getLanguageCodes().map((x) => {
      form['reference_' + x] = '';
      form['slug_' + x] = '';
      form['description_' + x] = '';

      // form['description_' + x] = '';
    });

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes(),
      languageNames: store.getLanguageNames(),
      templateOptions: [],
      categoryOptions: [],
      formulaOptions: [],
      interliningOptions: [],
      initialsSizesOptions: [],
      embroideriesSizesOptions: [],
      form: form,
      attributeSelectorOptions: {},
      reAssignProductAttr: false,
      genericProductAttributesOptions: [
        {
          reference: 'Familia de producto',
          options: [],
        },
        {
          reference: 'Producto',
          options: [],
        },
        {
          reference: 'Modelo',
          options: [],
        },
        {
          reference: 'Caracteristica 1',
          options: [],
        },
        {
          reference: 'Caracteristica 2',
          options: [],
        },
      ],
      workshopTasksOptions: [],
      productHierarchy: [],
      attributeSelectorDefaultOptions: {},
      attributes: [],
      type: 'offline',
      selectableAttributeTypes: [
        'TAMANO',
        'TAMANO_LIBRE',
        'TAMANO_LIBRE_CAMA',
        'TAMANO_DIAM',
        'CAIDA',
        'TELA',
        'HILO',
        'PUNTADA',
        'TIRA_BORDADA',
        'TIRA_BORDADA_CON_ENTREDOS',
        // 'HILO_PUNTADA',
        // 'BORDADO',
        // 'INICIALES',
      ],
      textileComponentsSelectableAttributeTypes: [
        'TELA',
        'HILO',
        'PUNTADA',
        'TIRA_BORDADA',
        'TIRA_BORDADA_CON_ENTREDOS',
        // 'HILO_PUNTADA',
        'TAMANO',
        'TAMANO_LIBRE',
        'TAMANO_LIBRE_CAMA',
        'TAMANO_DIAM',
        'CAIDA',
        'BORDADO',
        'INICIALES',
      ],
      constantBoxStyleLeft: {
        paddingRight: '2rem',
        borderRight: '1px solid #dedede',
      },
      constantBoxStyleRight: {
        paddingLeft: '2rem',
      },
      currentPriceFormulaUncoveredConstants: [],
      currentPriceFormulaUncoveredCuttingSizes: [],

      currentPriceFormulaUncoveredAutoInputs: [],

      cuttingSizesFormulaUncoveredConstants: [],
    };
  },
  computed: {
    currentFormula() {
      if (this.$v.form.formula.$model) {
        return this.formulaOptions.length > 0
          ? this.formulaOptions.find(
              (x) => x.value === this.$v.form.formula.$model
            ).extra.formula
          : null;
      }
      return null;
    },

    enableTextileComponentsSection() {
      return (
        (this.type === 'online' && this.form.textile_components.length > 0) ||
        this.type == 'offline'
      );
    },
    enableInitialsSection() {
      return (
        (this.type === 'offline' &&
          this.form.textile_components.findIndex(
            (x) => x.selector_type === 'INICIALES'
          ) >= 0) ||
        (this.type === 'online' &&
          this.attributes.findIndex((x) => x.reference === 'INICIALES') >= 0)
      );
    },
    enableEmbroideriesSection() {
      return (
        (this.type === 'offline' &&
          this.form.textile_components.findIndex(
            (x) => x.selector_type === 'BORDADO'
          ) >= 0) ||
        (this.type === 'online' &&
          this.attributes.findIndex((x) => ['BORDADO'].includes(x.reference)) >=
            0)
      );
    },
    enableSizeSelectorInput() {
      return (
        this.type === 'online' &&
        this.attributes.findIndex((x) => ['TAMANO'].includes(x.reference)) >= 0
      );
    },
  },
  created() {
    let promises = [];

    promises.push(actions.getProductTemplatesUnpaginated());
    promises.push(actions.getProductCategoriesUnpaginated());
    promises.push(actions.getInterliningsUnpaginated());
    promises.push(actions.getInitial(1));
    promises.push(actions.getEmbroiderySetting(1));
    promises.push(actions.getFormulasUnpaginated());
    // promises.push(actions.getGenericProductAttributesUnpaginated());
    promises.push(actions.getProductHierarchy());
    promises.push(actions.getWorkshopTasksUnpaginated());

    this.selectableAttributeTypes.forEach((attribute_type) => {
      promises.push(
        actions.getProductSelectorsByAttributeUnpaginated(attribute_type)
      );
    });

    Promise.all(promises).then((x) => {
      // 0
      this.templateOptions = x[0].data.results.map((y) => {
        return {
          value: y.reference,
          text: y.reference,
        };
      });

      // 1
      this.categoryOptions = x[1].data.results.map((y) => {
        return {
          value: y.id,
          text: (y.parent_name ? y.parent_name + ', ' : '') + y.reference,
        };
      });

      // 2
      this.interliningOptions = x[2].data.results.map((y) => {
        return {
          value: y.id,
          text: y.reference,
        };
      });

      // 3
      this.initialsSizesOptions = x[3].data.sizes.map((y) => {
        return {
          value: y.name,
          text: y.name,
          price: y.price,
        };
      });

      // 4
      this.embroideriesSizesOptions = x[4].data.sizes.map((y) => {
        return {
          value: y.name,
          text: y.name,
          price_unicolor: y.price_unicolor,
          price_multicolor: y.price_multicolor,
          height: y.height,
        };
      });

      // 5
      this.formulaOptions = x[5].data.results.map((y) => {
        return {
          value: y.id,
          text: y.reference,
          extra: {
            formula: y.formula,
          },
        };
      });

      // 6, Generic product attributes
      // this.genericProductAttributesOptions = x[6].data.results;

      // Hierarchy
      this.productHierarchy = x[6].data.results;
      this.populateAttrFields(this.productHierarchy, null);

      // Workshop tasks
      this.workshopTasksOptions = x[7].data.results;

      // 7, selectors

      let self = this;
      this.selectableAttributeTypes.forEach((attribute_type, index) => {
        this.$set(this.attributeSelectorOptions, attribute_type, []);

        x[8 + index].data.results.map((y) => {
          this.attributeSelectorOptions[attribute_type].push({
            value: y.reference,
            text: y.reference,
          });
        });

        x[8 + index].data.results.map((y) => {
          this.$set(this.attributeSelectorDefaultOptions, y.reference, []);

          let arr = [];
          y.options.map((yy) => {
            arr.push({
              value: yy.value,
              text: yy.text,
            });
          });
          this.$set(this.attributeSelectorDefaultOptions, y.reference, arr);
        });

        // y.options.map((yy) => {
        //     this.attributeSelectorDefaultOptions[attribute_type].push({
        //       value: yy.value,
        //       text: yy.text,
        //     });
        //   });
      });

      // this.selectableDefaultValues\
      // attributeSelectorOptions[v.selector_type.$model]

      // this.loadPossibleSelectors('TELA');
      if (this.id === 'new') {
        this.reAssignProductAttr = true;
        // TODO remove
        // this.type = 'online';
        // this.$v.form.template.$model = 'IND_ABS';
        // this.templateChanged('IND_ABS');
        // end TODO
      } else {
        actions.getProduct(this.id).then((y) => {
          const data = y.data;

          this.type = data.type;

          this.form.reference = data.reference;
          this.form.slug = data.slug;
          this.form.description = data.description;

          // console.log('PE', data.generic_product_attributes);
          this.form.generic_product_attributes =
            data.generic_product_attributes;

          // this.refreshAttrFieldsAll();

          // this.refreshAttrFields('Sub-producto');
          // this.refreshAttrFields('Sub-producto');

          this.form.product_tasks = data.product_tasks;
          this.form.product_tasks.map((x) => {
            this.workshopTasksOptions.find(
              (y) => y.code === x.code
            ).$isDisabled = true;
          });

          this.languageCodes.map((y) => {
            this.form['reference_' + y] = data['reference_' + y];
            this.form['slug_' + y] = data['slug_' + y];
            this.form['description_' + y] = data['description_' + y];
          });

          this.form.price = data.price;
          this.form.is_price_variable = data.is_price_variable;
          this.form.hidden = data.hidden;
          this.form.formula = data.formula;

          this.form.attributes = data.attributes;
          this.form.template = data.template;
          this.form.category = data.category;
          this.form.imageURI = data.image;

          this.form.textile_components = data.textile_components;
          this.form.interlinings = data.interlinings;
          this.form.initials_sizes = data.initials_sizes;

          this.form.cutting_sizes = data.cutting_sizes;
          this.form.embroideries_sizes = data.embroideries_sizes;
          this.form.constants_price = data.constants_price;

          this.form.constants_cutting_sizes = data.constants_cutting_sizes;

          this.form.costs = data.costs;
          this.form.constants_costs = data.constants_costs;
          this.form.profit_margin = data.profit_margin;

          this.form.is_discontinued = data.is_discontinued;
          this.form.partially_available_stock_can_be_reused =
            data.partially_available_stock_can_be_reused;

          // this.form.selector_size = data.selector_size;

          this.populateCuttingSizes();

          if (data.type === 'online') {
            actions.getProductTemplate(this.form.template).then((yyy) => {
              this.attributes = yyy.data.definition.attributes;

              // this.attributes
              //   .filter(
              //     (v, i, a) =>
              //       a.findIndex((t) => t.reference === v.reference) === i
              //   )
              //   .map((z) => {
              //     this.loadPossibleSelectors(z.reference);
              //   });
            });
          }
        });
      }
    });
  },
  methods: {
    refreshAttrFields(updatedFieldName) {
      const family = this.form.generic_product_attributes[
        'Familia de producto'
      ];
      const product = this.form.generic_product_attributes['Producto'];
      const model = this.form.generic_product_attributes['Modelo'];
      const characteristic1 = this.form.generic_product_attributes[
        'Caracteristica 1'
      ];
      const characteristic2 = this.form.generic_product_attributes[
        'Caracteristica 2'
      ];

      let params = {};

      if (family) {
        params['family'] = family;
      }

      if (product && !['Familia de producto'].includes(updatedFieldName)) {
        params['product'] = product;
      }

      if (
        model &&
        !['Familia de producto', 'Producto'].includes(updatedFieldName)
      ) {
        params['model'] = model;
      }

      if (
        characteristic1 &&
        !['Familia de producto', 'Producto', 'Modelo'].includes(
          updatedFieldName
        )
      ) {
        params['characteristic1'] = characteristic1;
      }

      if (
        characteristic2 &&
        ![
          'Familia de producto',
          'Producto',
          'Modelo',
          'Caracteristica 1',
        ].includes(updatedFieldName)
      ) {
        params['characteristic2'] = characteristic2;
      }

      actions.getProductHierarchy(params).then((res) => {
        const hierarchyArr = res.data.results;
        this.populateAttrFields(hierarchyArr, updatedFieldName);
      });
    },
    populateAttrFields(productHierarchy, updatedFieldName) {
      let attrFamilyOptions = [
        ...new Set(
          productHierarchy.filter((afo) => afo.family).map((afo) => afo.family)
        ),
      ];

      let attrProductOptions = [
        ...new Set(
          productHierarchy
            .filter((apo) => apo.product)
            .map((apo) => apo.product)
        ),
      ];

      let attrModelOptions = [
        ...new Set(
          productHierarchy.filter((amo) => amo.model).map((amo) => amo.model)
        ),
      ];

      let attrCharacteristic1Options = [
        ...new Set(
          productHierarchy
            .filter((aspo) => aspo.characteristic1)
            .map((aspo) => aspo.characteristic1)
        ),
      ];

      let attrCharacteristic2Options = [
        ...new Set(
          productHierarchy
            .filter((aspo) => aspo.characteristic2)
            .map((aspo) => aspo.characteristic2)
        ),
      ];

      if (!updatedFieldName) {
        // First init, load everything
        this.genericProductAttributesOptions[0].options = attrFamilyOptions;
        this.genericProductAttributesOptions[1].options = attrProductOptions;
        this.genericProductAttributesOptions[2].options = attrModelOptions;
        this.genericProductAttributesOptions[3].options = attrCharacteristic1Options;
        this.genericProductAttributesOptions[4].options = attrCharacteristic2Options;

        // this.refreshAttrFields('Modelo');
      } else if (updatedFieldName == 'Familia de producto') {
        // Clear values
        this.$set(this.form.generic_product_attributes, 'Producto', null);
        this.$set(this.form.generic_product_attributes, 'Modelo', null);
        this.$set(
          this.form.generic_product_attributes,
          'Caracteristica 1',
          null
        );
        this.$set(
          this.form.generic_product_attributes,
          'Caracteristica 2',
          null
        );

        // Clear product tasks as we changed family
        this.form.product_tasks = [];

        // Populate options
        this.genericProductAttributesOptions[1].options = attrProductOptions;
        this.genericProductAttributesOptions[2].options = attrModelOptions;
        this.genericProductAttributesOptions[3].options = attrCharacteristic1Options;
        this.genericProductAttributesOptions[4].options = attrCharacteristic2Options;
      } else if (updatedFieldName == 'Producto') {
        this.$set(this.form.generic_product_attributes, 'Modelo', null);
        this.$set(
          this.form.generic_product_attributes,
          'Caracteristica 1',
          null
        );
        this.$set(
          this.form.generic_product_attributes,
          'Caracteristica 2',
          null
        );

        this.genericProductAttributesOptions[2].options = attrModelOptions;
        this.genericProductAttributesOptions[3].options = attrCharacteristic1Options;
        this.genericProductAttributesOptions[4].options = attrCharacteristic2Options;
      } else if (updatedFieldName == 'Modelo') {
        this.$set(
          this.form.generic_product_attributes,
          'Caracteristica 1',
          null
        );
        this.$set(
          this.form.generic_product_attributes,
          'Caracteristica 2',
          null
        );

        // Populate options
        this.genericProductAttributesOptions[3].options = attrCharacteristic1Options;
        this.genericProductAttributesOptions[4].options = attrCharacteristic2Options;
      } else if (updatedFieldName == 'Caracteristica 1') {
        this.$set(
          this.form.generic_product_attributes,
          'Caracteristica 2',
          null
        );

        // Populate options
        this.genericProductAttributesOptions[4].options = attrCharacteristic2Options;
      }
    },

    // refreshAttrFieldsAll: async () => {
    //   const selectedValuesClone = Object.assign(
    //     {},
    //     this.form.generic_product_attributes
    //   );

    //   let arrRefreshAttFields = [];
    //   if (selectedValuesClone['Familia de producto'])
    //     arrRefreshAttFields.push('Familia de producto');

    //   if (selectedValuesClone['Producto']) arrRefreshAttFields.push('Producto');

    //   if (selectedValuesClone['Sub-producto'])
    //     arrRefreshAttFields.push('Sub-producto');

    //   if (selectedValuesClone['Tipo']) arrRefreshAttFields.push('Tipo');

    //   if (selectedValuesClone['Modelo']) arrRefreshAttFields.push('Modelo');

    //   for (let index = 0; index < arrRefreshAttFields.length; index++) {
    //     const element = arrRefreshAttFields[index];
    //     if (element == 'Familia de producto') {
    //       await this.refreshAttrFields('Familia de producto');
    //     } else if (element == 'Producto') {
    //       this.$set(
    //         this.form.generic_product_attributes,
    //         'Producto',
    //         selectedValuesClone['Producto']
    //       );
    //       this.refreshAttrFields('Producto');
    //       // this.refreshAttrFields('Producto');
    //     }
    //   }
    // },
    // swapProductTasks(i, j) {
    //   this.form.product_tasks[i] = this.form.product_tasks.splice(
    //     j,
    //     1,
    //     this.form.product_tasks[i]
    //   )[0];
    // },
    // moveProductTaskUp(i) {
    //   i = parseInt(i);
    //   this.swapProductTasks(i, i - 1);
    // },
    // moveProductTaskDown(i) {
    //   i = parseInt(i);
    //   this.swapProductTasks(i, i + 1);
    // },
    deleteTask(taskCode, i) {
      this.workshopTasksOptions.find(
        (x) => x.code === taskCode
      ).$isDisabled = false;

      this.form.product_tasks.splice(i, 1);

      this.orderWorkthopTasks();
    },
    workshopTaskClicked(val) {
      this.form.product_tasks.push(val);
      this.workshopTasksOptions.find(
        (x) => x.code === val.code
      ).$isDisabled = true;

      this.orderWorkthopTasks();
    },
    orderWorkthopTasks() {
      this.form.product_tasks = this.form.product_tasks.sort((x, y) =>
        x.code.localeCompare(y.code)
      );
    },
    workshopTaskNameFmt({ code, description }) {
      return `${code} - ${description}`;
    },
    genericProductAttributeValue(name) {
      if (
        !this.form.generic_product_attributes ||
        !this.form.generic_product_attributes[name]
      )
        return null;

      return this.form.generic_product_attributes[name];
    },
    setGenericProductAttribute(name, val) {
      if (val) {
        this.$set(this.form.generic_product_attributes, name, val);
        this.refreshAttrFields(name);
      }
    },
    swapAttributes(i, j) {
      this.form.attributes[i] = this.form.attributes.splice(
        j,
        1,
        this.form.attributes[i]
      )[0];
    },
    moveUp(i) {
      i = parseInt(i);
      this.swapAttributes(i, i - 1);
    },
    moveDown(i) {
      i = parseInt(i);
      this.swapAttributes(i, i + 1);
    },
    capitalizeWords(string) {
      return string.replace(/(?:^|\s)\S/g, function (a) {
        return a.toUpperCase();
      });
    },
    changedName(val) {
      this.$v.form.reference.$model = this.capitalizeWords(val);
    },
    EmbroiderySizeChanged(i) {
      const sizeName = this.$v.form.embroideries_sizes.$each.$iter[i].size
        .$model;
      const element = this.embroideriesSizesOptions.find(
        (x) => x.text === sizeName
      );

      this.$v.form.embroideries_sizes.$each.$iter[i].price_unicolor.$model =
        element.price_unicolor;

      this.$v.form.embroideries_sizes.$each.$iter[i].price_multicolor.$model =
        element.price_multicolor;

      this.$v.form.embroideries_sizes.$each.$iter[i].height.$model =
        element.height;
    },
    InitialSizeChanged(i) {
      const sizeName = this.$v.form.initials_sizes.$each.$iter[i].size.$model;
      const price = this.initialsSizesOptions.find((x) => x.text === sizeName)
        .price;

      this.$v.form.initials_sizes.$each.$iter[i].price.$model = price;
    },

    /* Price Formulas */
    removeUnusedPriceFormulaConstants() {
      // take all the formulas

      let formula = this.currentFormula;

      // for (let index = 0; index < this.form.constants_price.length; index++) {
      //   const element = this.form.constants_price[index];
      //   formula += element.formula_width + ' ' + element.formula_length;
      // }

      for (
        let index = this.form.constants_price.length - 1;
        index >= 0;
        index--
      ) {
        const key = this.form.constants_price[index].key;

        if (formula.indexOf(key) === -1) {
          this.form.constants_price.splice(index, 1);
        }
      }
    },

    // priceFormulaChanged() {
    //   this.updatePriceFormulaMissingConstants();
    //   this.updatePriceFormulaMissingCuttingSizes();
    //   this.updatePriceFormulaMissingAutoInputs();
    //   this.updatePriceFormulaAttributesWithInputs();
    // },
    updatePriceFormulaAttributesWithInputs() {
      if (this.type === 'offline') {
        let declaredAttributes = this.form.attributes;

        let formula = this.currentFormula;
        const regexp_constants = /(I_[A-Z0-9_]+)/g;

        if (regexp_constants.test(formula)) {
          const arr_inputs = [...formula.match(regexp_constants)];

          arr_inputs.map((x) => {
            if (
              declaredAttributes.length === 0 ||
              declaredAttributes.find((y) => 'I_' + y.input === x) === undefined
            ) {
              this.form.attributes.push({
                name: '',
                is_input: true,
                input: x.replace('I_', ''),
              });
            }
          });
        }

        this.removeUnusedAttributesInputs();
      }
    },
    // updatePriceFormulaMissingCuttingSizes() {
    //   let formula = this.currentFormula;
    //   const regexp_constants = /(MC\[([A-zÀ-ú0-9_ ]+)\]\[(ANCHO|LARGO|DIAM)\])/g;
    //   let arr_undefined_constants = [];

    //   if (regexp_constants.test(formula)) {
    //     const arr_constants = [...formula.match(regexp_constants)];

    //     arr_constants.map((x) => {
    //       let cuttingSizeName = x.split('[')[1].replace(']', '');
    //       let cuttingSizeTypeDimension = x.split('[')[2].replace(']', '');

    //       let expectedType = {
    //         ANCHO: 'rectangle',
    //         LARGO: 'rectangle',
    //         DIAM: 'circle',
    //       }[cuttingSizeTypeDimension];

    //       let matchedCuttingSize = this.form.cutting_sizes.filter(
    //         (y) =>
    //           y.name === cuttingSizeName && y.type_dimension === expectedType
    //       );

    //       if (matchedCuttingSize.length === 0) {
    //         arr_undefined_constants.push(x);
    //       }
    //     });
    //   }

    //   this.currentPriceFormulaUncoveredCuttingSizes = arr_undefined_constants;
    // },
    updatePriceFormulaMissingConstants() {
      let declaredConstants = this.form.constants_price;
      let formula = this.currentFormula;
      const regexp_constants = /(C_[A-Z0-9_]+)/g;
      let arr_undefined_constants = [];

      if (regexp_constants.test(formula)) {
        const arr_constants = [...formula.match(regexp_constants)];

        arr_constants.map((x) => {
          if (
            declaredConstants.length === 0 ||
            declaredConstants.find((y) => 'C_' + y.key === x) === undefined
          ) {
            arr_undefined_constants.push(x);
          }
        });
      }

      let newConstantsPush = [];

      // initially pre-load constants
      for (
        let index = arr_undefined_constants.length - 1;
        index >= 0;
        index--
      ) {
        const element = arr_undefined_constants[index];

        if (
          this.form.constants_price.findIndex(
            (x) => x.key === element.replace('C_', '')
          ) === -1
        ) {
          newConstantsPush.push({
            key: element.replace('C_', ''),
            name: '',
            value: '',
          });
          arr_undefined_constants.splice(index, 1);
        }
      }

      newConstantsPush.reverse().map((y) => {
        this.form.constants_price.push(y);
      });

      // // initially pre-load constants
      // for (let index = 0; index < arr_undefined_constants.length; index++) {
      //   const element = arr_undefined_constants[index];
      //   this.form.constants_price.push({
      //     key: element.replace('C_', ''),
      //     name: '',
      //     value: '',
      //   });
      // }

      this.currentPriceFormulaUncoveredConstants = arr_undefined_constants;

      this.removeUnusedPriceFormulaConstants();
    },

    // updatePriceFormulaMissingAutoInputs() {
    //   let formula = this.currentFormula;
    //   const regexp_autoinputs = /(IA_[A-Z0-9_]+)/g;
    //   let arr_undefined_autoinputs = [];

    //   if (regexp_autoinputs.test(formula)) {
    //     const arr_autoinputs = [...formula.match(regexp_autoinputs)];

    //     arr_autoinputs.map((x) => {
    //       // TODO read from database
    //       let found = false;
    //       if (x === 'IA_PRECIO_TIRA_BORDADA' || x === 'IA_ANCHO_TIRA_BORDADA') {
    //         found =
    //           this.form.textile_components.filter(
    //             (y) =>
    //               y.selector_type === 'TIRA_BORDADA' ||
    //               y.selector_type === 'TIRA_BORDADA_CON_ENTREDOS'
    //           ).length > 0;
    //       } else if (x === 'IA_PRECIO_ENTREDOS') {
    //         found =
    //           this.form.textile_components.filter(
    //             (y) => y.selector_type === 'TIRA_BORDADA_CON_ENTREDOS'
    //           ).length > 0;
    //       } else if (
    //         x === 'IA_PRECIO_METRO_TELA' ||
    //         x === 'IA_ANCHO_TELA' ||
    //         x === 'IA_PRECIO_CM_TELA' ||
    //         x === 'IA_COSTE_METRO_TELA' ||
    //         x === 'IA_COSTE_CM_TELA'
    //       ) {
    //         found =
    //           this.form.textile_components.filter(
    //             (y) => y.selector_type === 'TELA'
    //           ).length > 0;
    //       } else if (
    //         x === 'IA_ANCHO_ENTRETELA' ||
    //         x === 'IA_LARGO_ENTRETELA' ||
    //         x === 'IA_COSTE_CM_ENTRETELA'
    //       ) {
    //         found = this.form.interlinings.length > 0;
    //       } else if (
    //         x === 'IA_PRECIO_METRO_HILO' ||
    //         x === 'IA_PRECIO_CM_HILO'
    //       ) {
    //         found =
    //           this.form.textile_components.filter(
    //             (y) => y.selector_type === 'HILO'
    //           ).length > 0;
    //       }

    //       if (!found) {
    //         arr_undefined_autoinputs.push(x);
    //       }
    //     });
    //   }

    //   this.currentPriceFormulaUncoveredAutoInputs = arr_undefined_autoinputs;
    // },

    updateAllPriceFormulaMissingConstants() {
      for (let index = 0; index < this.form.cutting_sizes.length; index++) {
        this.updatePriceFormulaMissingConstants(index);
      }
    },

    /* Cutting sizes */
    removeUnusedCuttingSizeConstants() {
      // take all the formulas

      let allFormulas = '';

      for (let index = 0; index < this.form.cutting_sizes.length; index++) {
        const element = this.form.cutting_sizes[index];
        allFormulas +=
          element.formula_width +
          ' ' +
          element.formula_length +
          ' ' +
          element.formula_diameter;
      }

      for (
        let index = this.form.constants_cutting_sizes.length - 1;
        index >= 0;
        index--
      ) {
        const key = this.form.constants_cutting_sizes[index].key;

        if (allFormulas.indexOf(key) === -1) {
          this.form.constants_cutting_sizes.splice(index, 1);
        }
      }
    },
    removeUnusedCostConstants() {
      // take all the formulas

      let allFormulas = '';

      for (let index = 0; index < this.form.costs.length; index++) {
        const element = this.form.costs[index];
        allFormulas += element.formula;
      }

      for (
        let index = this.form.constants_costs.length - 1;
        index >= 0;
        index--
      ) {
        const key = this.form.constants_costs[index].key;

        if (allFormulas.indexOf(key) === -1) {
          this.form.constants_costs.splice(index, 1);
        }
      }
    },
    setDecimalCuttingSize(index, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.cutting_sizes.$each.$iter[index][name].$model = val;
      this.$v.form.cutting_sizes.$each.$iter[index][name].$touch();
    },
    setDecimalCost(index, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot

      this.$v.form.costs.$each.$iter[index][name].$model = val;
      this.$v.form.costs.$each.$iter[index][name].$touch();
    },
    cuttingSizeFormulaChanged(index) {
      this.updateCuttingSizeFormulaMissingConstants(index);
      this.updateCuttingSizeFormulaAttributesWithInputs(index);
    },
    costFormulaChanged(index) {
      this.updateCostFormulaMissingConstants(index);
      this.updateCostFormulaAttributesWithInputs(index);
    },
    updateCuttingSizeFormulaAttributesWithInputs(i) {
      if (this.type === 'offline') {
        let declaredAttributes = this.form.attributes;

        let formula =
          this.$v.form.cutting_sizes.$each.$iter[i].formula_width.$model +
          ' ' +
          this.$v.form.cutting_sizes.$each.$iter[i].formula_length.$model +
          ' ' +
          this.$v.form.cutting_sizes.$each.$iter[i].formula_diameter.$model;
        const regexp_constants = /(I_[A-Z0-9_]+)/g;

        if (regexp_constants.test(formula)) {
          const arr_inputs = [...formula.match(regexp_constants)];

          arr_inputs.map((x) => {
            if (
              declaredAttributes.length === 0 ||
              declaredAttributes.find((y) => 'I_' + y.input === x) === undefined
            ) {
              this.form.attributes.push({
                name: '',
                is_input: true,
                input: x.replace('I_', ''),
              });
            }
          });
        }

        this.removeUnusedAttributesInputs();
      }
    },

    updateCostFormulaAttributesWithInputs(i) {
      if (this.type === 'offline') {
        let declaredAttributes = this.form.attributes;

        let formula = this.$v.form.costs.$each.$iter[i].formula.$model;
        const regexp_constants = /(I_[A-Z0-9_]+)/g;

        if (regexp_constants.test(formula)) {
          const arr_inputs = [...formula.match(regexp_constants)];

          arr_inputs.map((x) => {
            if (
              declaredAttributes.length === 0 ||
              declaredAttributes.find((y) => 'I_' + y.input === x) === undefined
            ) {
              this.form.attributes.push({
                name: '',
                is_input: true,
                input: x.replace('I_', ''),
              });
            }
          });
        }

        this.removeUnusedAttributesInputs();
      }
    },

    updateAllCuttingSizeFormulaMissingConstants() {
      for (let index = 0; index < this.form.cutting_sizes.length; index++) {
        this.updateCuttingSizeFormulaMissingConstants(index);
      }
    },
    updateCuttingSizeFormulaMissingConstants(i) {
      let declaredConstants = this.form.constants_cutting_sizes;
      let formula =
        this.$v.form.cutting_sizes.$each.$iter[i].formula_width.$model +
        ' ' +
        this.$v.form.cutting_sizes.$each.$iter[i].formula_length.$model +
        ' ' +
        this.$v.form.cutting_sizes.$each.$iter[i].formula_diameter.$model;

      const regexp_constants = /(C_[A-Z0-9_]+)/g;
      let arr_undefined_constants = [];

      if (regexp_constants.test(formula)) {
        const arr_constants = [...formula.match(regexp_constants)];

        arr_constants.map((x) => {
          if (
            declaredConstants.length === 0 ||
            declaredConstants.find((y) => 'C_' + y.key === x) === undefined
          ) {
            arr_undefined_constants.push(x);
          }
        });
      }

      let newConstantsPush = [];

      // initially pre-load constants
      for (
        let index = arr_undefined_constants.length - 1;
        index >= 0;
        index--
      ) {
        const element = arr_undefined_constants[index];

        if (
          this.form.constants_cutting_sizes.findIndex(
            (x) => x.key === element.replace('C_', '')
          ) === -1
        ) {
          newConstantsPush.push({
            key: element.replace('C_', ''),
            name: '',
            value: '',
          });
          arr_undefined_constants.splice(index, 1);
        }
      }

      newConstantsPush.reverse().map((y) => {
        this.form.constants_cutting_sizes.push(y);
      });

      this.$set(
        this.cuttingSizesFormulaUncoveredConstants,
        i,
        arr_undefined_constants
      );

      this.removeUnusedCuttingSizeConstants();
    },

    updateCostFormulaMissingConstants(i) {
      let declaredConstants = this.form.constants_costs;
      let formula = this.$v.form.costs.$each.$iter[i].formula.$model;
      const regexp_constants = /(C_[A-Z0-9_]+)/g;
      let arr_undefined_constants = [];

      if (regexp_constants.test(formula)) {
        const arr_constants = [...formula.match(regexp_constants)];

        arr_constants.map((x) => {
          if (
            declaredConstants.length === 0 ||
            declaredConstants.find((y) => 'C_' + y.key === x) === undefined
          ) {
            arr_undefined_constants.push(x);
          }
        });
      }

      let newConstantsPush = [];

      // initially pre-load constants
      for (
        let index = arr_undefined_constants.length - 1;
        index >= 0;
        index--
      ) {
        const element = arr_undefined_constants[index];

        if (
          this.form.constants_costs.findIndex(
            (x) => x.key === element.replace('C_', '')
          ) === -1
        ) {
          newConstantsPush.push({
            key: element.replace('C_', ''),
            name: '',
            value: '',
          });
          arr_undefined_constants.splice(index, 1);
        }
      }

      newConstantsPush.reverse().map((y) => {
        this.form.constants_costs.push(y);
      });

      this.removeUnusedCostConstants();
    },

    validateStateCuttingSize(index, name) {
      const { $dirty, $error } = this.$v.form.cutting_sizes.$each.$iter[index][
        name
      ];
      return $dirty ? !$error : null;
    },

    validateStateCost(index, name) {
      const { $dirty, $error } = this.$v.form.costs.$each.$iter[index][name];
      return $dirty ? !$error : null;
    },

    textileComponentTypeChanged() {
      this.populateCuttingSizes();
      // this.updatePriceFormulaMissingAutoInputs();
    },

    populateCuttingSizes() {
      let formulas = [];

      for (let index = 0; index < this.form.cutting_sizes.length; index++) {
        const element = this.form.cutting_sizes[index];
        formulas.push({
          formula_width: element.formula_width,
          formula_length: element.formula_length,
          formula_diameter: element.formula_diameter,
          type_dimension: element.type_dimension,
        });
      }

      this.form.cutting_sizes = [];

      // Textile components
      this.form.textile_components.map((x, i) => {
        if (
          ['TELA', 'TIRA_BORDADA', 'TIRA_BORDADA_CON_ENTREDOS'].includes(
            x.selector_type
          )
        ) {
          this.form.cutting_sizes.push({
            type: ['TIRA_BORDADA', 'TIRA_BORDADA_CON_ENTREDOS'].includes(
              x.selector_type
            )
              ? 'embroidered_strip'
              : 'textile_component',
            index: i,
            name: x.name,
            formula_width: '',
            formula_length: '',
            formula_diameter: '',
            type_dimension: 'rectangle',
          });
          this.cuttingSizesFormulaUncoveredConstants.push([]);
        }

        if (['TIRA_BORDADA_CON_ENTREDOS'].includes(x.selector_type)) {
          this.form.cutting_sizes.push({
            type: 'embroidered_strip_plane',
            index: i,
            name: 'Entredós de ' + x.name,
            formula_width: '',
            formula_length: '',
            formula_diameter: '',
            type_dimension: 'rectangle',
          });
          this.cuttingSizesFormulaUncoveredConstants.push([]);
        }
      });
      // Interlinings
      this.form.interlinings.map((x, i) => {
        this.form.cutting_sizes.push({
          type: 'interlining',
          index: i,
          name: x.interlining_id
            ? this.interliningOptions.find((y) => y.value === x.interlining_id)
                .text
            : '',
          formula_width: '',
          formula_length: '',
          formula_diameter: '',
          type_dimension: 'rectangle',
        });
        this.cuttingSizesFormulaUncoveredConstants.push([]);
      });

      for (let index = 0; index < formulas.length; index++) {
        this.form.cutting_sizes[index].formula_width =
          formulas[index].formula_width;
        this.form.cutting_sizes[index].formula_length =
          formulas[index].formula_length;
        this.form.cutting_sizes[index].formula_diameter =
          formulas[index].formula_diameter;
        this.form.cutting_sizes[index].type_dimension =
          formulas[index].type_dimension;
      }

      // this.updatePriceFormulaMissingCuttingSizes();
    },

    populateTextileComponents() {
      this.form.textile_components = [];

      this.attributes
        .filter((x) =>
          [
            'TELA',
            'HILO',
            'PUNTADA',
            'TAMANO',
            // 'HILO_PUNTADA',
            'BORDADO',
            'CAIDA',
            'TAMANO_LIBRE',
            'TAMANO_LIBRE_CAMA',
            'TAMANO_DIAM',
            'INICIALES',
          ].includes(x.reference)
        )
        .map((y) => {
          this.form.textile_components.push({
            name: y.label,
            selector_type: y.reference,
            selector_id: null,
            selector_default_value: null,
          });
        });
    },

    /* Attributes */
    removeUnusedAttributesInputs() {
      if (this.form.attributes.length === 0) {
        return false;
      }

      let inputs = this.form.attributes
        .filter((x) => x.is_input)
        .map((y) => y.input);

      let allFormulas = ''; //this.currentFormula;
      for (let index = 0; index < this.form.cutting_sizes.length; index++) {
        allFormulas +=
          this.form.cutting_sizes[index].formula_width +
          ' ' +
          this.form.cutting_sizes[index].formula_length +
          ' ' +
          this.form.cutting_sizes[index].formula_diameter;
      }

      for (let index = 0; index < this.form.costs.length; index++) {
        allFormulas += this.form.costs[index].formula;
      }

      inputs.map((x, index) => {
        if (allFormulas.indexOf('I_' + x) < 0) {
          this.form.attributes.splice(index, 1);
        }
      });
    },

    validateStateAttributes(index, name) {
      const { $dirty, $error } = this.$v.form.attributes.$each.$iter[index][
        name
      ];
      return $dirty ? !$error : null;
    },

    /* Price constants */
    changedPriceConstantKey(i) {
      this.updatePriceFormulaMissingConstants();
    },

    addPriceConstant() {
      this.form.constants_price.push({
        key: '',
        name: '',
        value: '',
      });
    },

    validateStatePriceConstant(index, name) {
      const { $dirty, $error } = this.$v.form.constants_price.$each.$iter[
        index
      ][name];
      return $dirty ? !$error : null;
    },

    removePriceConstant(i) {
      this.form.constants_price.splice(i, 1);
      this.updatePriceFormulaMissingConstants();
      this.updateAllPriceFormulaMissingConstants();
    },

    setDecimalPriceConstant(index, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.constants_price.$each.$iter[index][name].$model = val;
      this.$v.form.constants_price.$each.$iter[index][name].$touch();
    },

    /* Cutting size constants */
    changedCuttingSizeConstantKey(i) {
      this.updateCuttingSizeFormulaMissingConstants(i);
      //this.updateAllCuttingSizeFormulaMissingConstants();
    },

    changedCostConstantKey(i) {
      this.updateCostFormulaMissingConstants(i);
      //this.updateAllCuttingSizeFormulaMissingConstants();
    },

    addCuttingSizeConstant() {
      this.form.constants_cutting_sizes.push({
        key: '',
        name: '',
        value: '',
      });
    },

    validateStateCuttingSizeConstant(index, name) {
      const {
        $dirty,
        $error,
      } = this.$v.form.constants_cutting_sizes.$each.$iter[index][name];
      return $dirty ? !$error : null;
    },

    validateStateCostConstant(index, name) {
      const { $dirty, $error } = this.$v.form.constants_costs.$each.$iter[
        index
      ][name];
      return $dirty ? !$error : null;
    },

    removeCuttingSizeConstant(i) {
      this.form.constants_cutting_sizes.splice(i, 1);
      this.updateAllCuttingSizeFormulaMissingConstants();
    },

    setDecimalCuttingSizeConstant(index, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.constants_cutting_sizes.$each.$iter[index][
        name
      ].$model = val;
      this.$v.form.constants_cutting_sizes.$each.$iter[index][name].$touch();
    },

    setDecimalCostConstant(index, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.constants_costs.$each.$iter[index][name].$model = val;
      this.$v.form.constants_costs.$each.$iter[index][name].$touch();
    },

    /* Textile components */
    removeTextileComponent(index) {
      this.form.textile_components.splice(index, 1);
    },
    removeCost(index) {
      this.form.costs.splice(index, 1);
    },
    addTextileComponent() {
      this.form.textile_components.push({
        name: '',
        selector_id: null,
        selector_type: null,
        selector_default_value: null,
      });
    },

    setDecimalTextileComponent(index, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.textile_components.$each.$iter[index][name].$model = val;
      this.$v.form.textile_components.$each.$iter[index][name].$touch();
    },
    validateStateTextileComponent(index, name) {
      const { $dirty, $error } = this.$v.form.textile_components.$each.$iter[
        index
      ][name];

      return $dirty ? !$error : null;
    },

    /* Embroideries */

    addEmbroiderySize() {
      this.form.embroideries_sizes.push({
        size: null,
        height: '',
        price_unicolor: '',
        price_multicolor: '',
      });
    },

    removeEmbroiderySize(i) {
      this.form.embroideries_sizes.splice(i, 1);
    },

    validateStateEmbroidery(index, name) {
      const { $dirty, $error } = this.$v.form.embroideries_sizes.$each.$iter[
        index
      ][name];
      return $dirty ? !$error : null;
    },

    validateStateEmbroiderySize(index, name) {
      const { $dirty, $error } = this.$v.form.embroideries_sizes.$each.$iter[
        index
      ][name];
      return $dirty ? !$error : null;
    },

    setDecimalEmbroiderySize(index, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.embroideries_sizes.$each.$iter[index][name].$model = val;
      this.$v.form.embroideries_sizes.$each.$iter[index][name].$touch();
    },

    populateEmbroideries() {
      let nEmbroideries = this.attributes.filter((x) =>
        ['BORDADO'].includes(x.reference)
      ).length;

      if (nEmbroideries >= 0) {
        this.form.embroideries_sizes.push({
          sizes: [
            {
              size: null,
              height: '',
              price: '',
            },
          ],
        });
      }
    },

    /* Interlinings */

    addInterlining() {
      this.form.interlinings.push({
        interlining_id: null,
      });

      this.populateCuttingSizes();
    },
    addCost() {
      this.form.costs.push({
        type: 'FREE',
        index: this.form.costs.length,
        name: '',
        formula: '',
      });
    },

    removeInterlining(i) {
      this.form.interlinings.splice(i, 1);

      this.populateCuttingSizes();
    },

    setDecimalInterlining(index, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.interlinings.$each.$iter[index][name].$model = val;
      this.$v.form.interlinings.$each.$iter[index][name].$touch();
    },

    validateStateInterlining(index, name) {
      const { $dirty, $error } = this.$v.form.interlinings.$each.$iter[index][
        name
      ];
      return $dirty ? !$error : null;
    },

    /* Initials */

    addInitialSize() {
      this.form.initials_sizes.push({
        size: null,
        price: '',
      });
    },

    removeInitialSize(i) {
      this.form.initials_sizes.splice(i, 1);
    },

    setDecimalInitialsSizes(index, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.initials_sizes.$each.$iter[index][name].$model = val;
      this.$v.form.initials_sizes.$each.$iter[index][name].$touch();
    },

    validateStateInitialsSizes(index, name) {
      const { $dirty, $error } = this.$v.form.initials_sizes.$each.$iter[index][
        name
      ];
      return $dirty ? !$error : null;
    },

    /* Global */

    typeChanged(val) {
      this.type = val;
      if (val === 'online') {
        for (let index = this.form.attributes.length - 1; index >= 0; index--) {
          const element = this.form.attributes[index];
          if (element.is_input) {
            this.form.attributes.splice(index, 1);
          }
        }
        //this.form.attributes = [];
      }
    },
    removeAttribute(index) {
      this.form.attributes.splice(index, 1);
    },

    addAttribute() {
      this.form.attributes.push({ is_input: false, name: '', input: '' });
    },

    setDecimal(name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form[name].$model = val;
      this.$v.form[name].$touch();
    },

    // loadPossibleSelectors(attribute_id) {
    //   this.$set(this.attributeSelectorOptions, attribute_id, []);

    //   let that = this;
    //   actions.getProductSelectorsByAttribute(attribute_id).then((x) => {
    //     x.data.results.map((y) => {
    //       that.attributeSelectorOptions[attribute_id].push({
    //         value: y.reference,
    //         text: y.reference,
    //       });
    //     });
    //   });
    // },
    templateChanged(val) {
      let that = this;

      actions.getProductTemplate(val).then((x) => {
        this.attributes = x.data.definition.attributes;

        // if (
        //   this.form.textile_components.length === 0 &&
        //   this.form.cutting_sizes.length === 0
        // ) {
        // TODO Al pasar de offline a online, si el offline ya tiene selectores, los nuevos del online se amontonan y no se pueden quitar. Hay que quitar selectores en offline, pasar a online y cargar el troquel. Entonces los selectores son los que deben ser, del online sólo.
        this.populateTextileComponents();
        this.populateCuttingSizes();

        // }
      });
    },
    getDataURIFromFile(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.readAsDataURL(file);
      });
    },
    changedImage(newFile) {
      this.getDataURIFromFile(newFile).then((result) => {
        this.form.imageURI = result;
      });
    },
    validateStateGlobal(name) {
      if (
        name === 'formula' &&
        (this.currentPriceFormulaUncoveredConstants.length > 0 ||
          this.currentPriceFormulaUncoveredAutoInputs.length > 0)
      ) {
        return false;
      }
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },

    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      let data = new FormData();

      if (this.form.image !== null) {
        data.append('image', this.form.image);
      }

      data.append('type', this.type);
      data.append('reference', this.form.reference_es);
      data.append('slug', this.form.slug_es);
      data.append('description', this.form.description_es);

      this.languageCodes.map((x) => {
        data.append('reference_' + x, this.form['reference_' + x]);
        data.append('slug_' + x, this.form['slug_' + x]);
        data.append('description_' + x, this.form['description_' + x]);
      });

      data.append('price', this.form.price);
      data.append('is_price_variable', this.form.is_price_variable);
      data.append('hidden', this.form.hidden);
      data.append('attributes', JSON.stringify(this.form.attributes));
      data.append('template', this.form.template ? this.form.template : '');
      if (this.form.category !== null) {
        data.append('category', parseInt(this.form.category));
      }

      if (this.form.formula !== null) {
        data.append('formula', parseInt(this.form.formula));
      }

      data.append(
        'textile_components',
        JSON.stringify(this.form.textile_components)
      );

      data.append(
        'generic_product_attributes',
        JSON.stringify(this.form.generic_product_attributes)
      );

      data.append(
        'product_tasks_write',
        JSON.stringify(this.form.product_tasks)
      );

      data.append('interlinings', JSON.stringify(this.form.interlinings));
      data.append('initials_sizes', JSON.stringify(this.form.initials_sizes));
      data.append(
        'embroideries_sizes',
        JSON.stringify(this.form.embroideries_sizes)
      );
      data.append('cutting_sizes', JSON.stringify(this.form.cutting_sizes));
      data.append('constants_price', JSON.stringify(this.form.constants_price));
      data.append(
        'constants_cutting_sizes',
        JSON.stringify(this.form.constants_cutting_sizes)
      );

      data.append('costs', JSON.stringify(this.form.costs));
      data.append('constants_costs', JSON.stringify(this.form.constants_costs));
      data.append('profit_margin', this.form.profit_margin);

      data.append('is_discontinued', this.form.is_discontinued);
      data.append(
        'partially_available_stock_can_be_reused',
        this.form.partially_available_stock_can_be_reused
      );
      // let data = {
      //   type: this.type,
      //   reference: this.form.reference,
      //   price: this.form.price,
      //   description: this.form.description,
      //   is_price_variable: this.form.is_price_variable,
      //   attributes: this.form.attributes,
      //   template: this.form.template,
      //   category: this.form.category,
      //   formula: this.form.formula,
      //   textile_components: this.form.textile_components,
      //   interlinings: this.form.interlinings,
      //   initials_sizes: this.form.initials_sizes,
      //   embroideries_sizes: this.form.embroideries_sizes,
      //   cutting_sizes: this.form.cutting_sizes,
      //   constants_price: this.form.constants_price,
      //   constants_cutting_sizes: this.form.constants_cutting_sizes,
      //   // selector_size: this.form.selector_size,
      // };
      if (this.id === 'new') {
        actions.postProduct(data).then((x) => {
          this.$router.push({ name: 'AdminProductsScreen' });
        });
      } else {
        actions.patchProduct(this.id, data).then((x) => {
          this.$router.push({ name: 'AdminProductsScreen' });
        });
      }

      store.setOverlayShow(true);
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
